import * as React from 'react';
import { useGetPriceQuery } from "../../../apis/Price.api";
import { PrimaryPrice, Price } from "../../../types/models/Price";
import TimberTypeName from "../../../../timber/components/timberType/TimberTypeDetail/TimberTypeName";
import TimberClassName from "../../../../timber/components/timberClass/TimberClassDetail/TimberClassName";
import ThicknessClassName from "../../../../timber/components/thicknessClass/ThicknessClassDetail/ThicknessClassName";
import {displayDateTime, displayDate, displayTime} from "../../../../utils/formatDate";

type IDisplayProps = {
    data: Price;
};

export const PriceNameDisplay: React.FC<IDisplayProps> = ({data}) => {
    if (data) {
        return (<><TimberTypeName id={ data?.timberTypeId }/>
                    {data?.classId && <> | </> }<TimberClassName id={ data?.classId }/>
                    {data?.thicknessClassId && <> | </> }<ThicknessClassName id={ data?.thicknessClassId }/>
                    </>)
    } else {
        return undefined
    }
}

type INameProps = {
    id: ID;

};

const PriceName: React.FC<INameProps> = ({id}) => {
    const { data } = useGetPriceQuery(PrimaryPrice.fromId(id))
    return (<PriceNameDisplay data={data}/>)
}

export default PriceName;
